var _circle, _g, _circle2, _circle3, _circle4, _circle5, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 120,
    viewBox: "0 0 153 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 52.0001,
    r: 52,
    fill: "#414040"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_4150_19318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.1 16.0001C67.3273 16.0001 57.7978 21.3234 51.9987 29.483C50.105 29.0364 48.1301 28.8001 46.1 28.8001C31.9615 28.8001 20.5 40.2616 20.5 54.4001C20.5 68.5386 31.9615 80.0001 46.1 80.0001L110.1 80.0001C122.471 80.0001 132.5 69.9713 132.5 57.6001C132.5 45.2289 122.471 35.2001 110.1 35.2001C109.221 35.2001 108.354 35.2507 107.502 35.3491C102.598 23.9678 91.2797 16.0001 78.1 16.0001Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.1,
    cy: 54.4001,
    rx: 25.6,
    ry: 25.6,
    fill: "url(#paint0_linear_4150_19318)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.0996,
    cy: 48.0001,
    r: 32,
    fill: "url(#paint1_linear_4150_19318)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.099,
    cy: 57.6001,
    rx: 22.4,
    ry: 22.4,
    fill: "url(#paint2_linear_4150_19318)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 19.0001,
    r: 5,
    fill: "#303030"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 109,
    r: 7,
    fill: "#303030"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.5,
    cy: 35.0001,
    r: 7,
    fill: "#303030"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.5,
    cy: 8.00011,
    r: 4,
    fill: "#303030"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_4150_19318)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 62.0001,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#AAAAAA",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4150_19318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.4995 90.0001L76.4995 86.0001M76.4995 86.0001L72.4995 90.0001M76.4995 86.0001V95.0001M84.8895 92.3901C85.8648 91.8584 86.6353 91.017 87.0793 89.9987C87.5234 88.9805 87.6157 87.8433 87.3417 86.7668C87.0677 85.6903 86.443 84.7356 85.5661 84.0536C84.6893 83.3715 83.6103 83.0008 82.4995 83.0001H81.2395C80.9368 81.8293 80.3726 80.7424 79.5894 79.8211C78.8062 78.8998 77.8243 78.168 76.7176 77.6807C75.6108 77.1935 74.408 76.9635 73.1996 77.008C71.9912 77.0525 70.8085 77.3704 69.7406 77.9378C68.6728 78.5051 67.7474 79.3072 67.0341 80.2837C66.3208 81.2602 65.8382 82.3856 65.6225 83.5755C65.4067 84.7654 65.4636 85.9886 65.7887 87.1534C66.1138 88.3181 66.6987 89.394 67.4995 90.3001",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_4150_19318",
    x: 0.5,
    y: 16.0001,
    width: 152,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_4150_19318"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4150_19318"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_4150_19318"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4150_19318",
    result: "effect2_dropShadow_4150_19318"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4150_19318",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_4150_19318",
    x: 44.5,
    y: 54.0001,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4150_19318"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4150_19318",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4150_19318",
    x1: 26.4429,
    y1: 37.4858,
    x2: 71.7,
    y2: 80.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4150_19318",
    x1: 53.5282,
    y1: 26.8573,
    x2: 110.1,
    y2: 80.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4150_19318",
    x1: 92.8992,
    y1: 42.8001,
    x2: 132.499,
    y2: 80.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4150_19318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(64.5 74.0001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.1bffe7d4cb27207e3a6b43c2bc200a0f.svg";
export { ForwardRef as ReactComponent };